export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_04.abd55be9.jpg";